module.exports = __webpack_public_path__ + "static/media/squeelo-normal.f5de6db7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/aliens/squeelo-normal.png
// module id = 168
// module chunks = 0